import { Injectable } from '@angular/core';
import { FlexBoard } from './flexBoard/flexBoard.page';

const ENC = "876fbae3fccae1348b";
const IV = "9df8765aeb3cf123";
const ALGO = "aes-256-cbc";
type NoteName = string; // e.g. "4C", "4A#", "5C"
type StartNote = string; // e.g. "F", "C#", "4F", "4C#"

export type FlexRowSetting = { row: number; start: StartNote };

export type FlexLayout = {
  numRows: number;     // 1..5
  numColumns: number;  // any positive
  rowSettings: FlexRowSetting[];
};

export type FlexBoardConfig = {
  validNotes: NoteName[]; // ordered list (this order defines “sequential notes”)
  defaultLayout: FlexLayout;
  phonePotrait?: FlexLayout;
  phoneLandscape?: FlexLayout;
};

export type KeyAssignment = { row: number; col: number; note: NoteName | null };

type LayoutName = "defaultLayout" | "phonePotrait" | "phoneLandscape";

/**
 * Compute key assignments for a given layout in FlexBoardConfig.
 * - For each row, find the first validNote that matches rowSettings[row].start
 *   (supports passing either "F"/"C#" or "4F"/"4C#" depending on your validNotes format).
 * - Then fill columns left->right with subsequent notes from validNotes.
 * - If start is not found OR we run out of validNotes, remaining cells are null.
 */
export function computeKeyAssignments(
  config: FlexBoardConfig,
  layoutName: LayoutName = "defaultLayout",
): KeyAssignment[] {
  const layout: FlexLayout =
    (config as any)[layoutName] ?? config.defaultLayout;

  const numRows = clampInt(layout.numRows, 1, 5);
  const numColumns = Math.max(0, Math.floor(layout.numColumns));

  // Map row -> start string (only rows present here have starts; others blank)
  const startByRow = new Map<number, StartNote>();
  for (const rs of layout.rowSettings ?? []) {
    if (Number.isFinite(rs.row)) startByRow.set(rs.row, rs.start);
  }

  const out: KeyAssignment[] = [];
  for (let r = 0; r < numRows; r++) {
    const start = startByRow.get(r);
    const startIdx = start ? findStartIndex(config.validNotes, start) : -1;

    for (let c = 0; c < numColumns; c++) {
      const idx = startIdx >= 0 ? startIdx + c : -1;
      const note = idx >= 0 && idx < config.validNotes.length ? config.validNotes[idx] : null;
      out.push({ row: r, col: c, note });
    }
  }
  return out;
}

/** Finds the first index where validNotes matches the given start. */
function findStartIndex(validNotes: NoteName[], start: StartNote): number {
  const s = normalize(start);

  // 1) Exact match first (e.g. start="4F" matches "4F")
  const exact = validNotes.findIndex(n => normalize(n) === s);
  if (exact >= 0) return exact;

  // 2) If start was octave-less (e.g. "F" / "C#"), match by pitch class
  //    Example: validNotes: ["4C","4C#","4D"...], start="C#" -> matches first "4C#"
  const pc = pitchClass(s);
  if (!pc) return -1;

  return validNotes.findIndex(n => pitchClass(normalize(n)) === pc);
}

function normalize(note: string): string {
  return String(note).trim().toUpperCase().replace(/\s+/g, "");
}

/** Returns pitch class like "C", "C#", "A#" from "4C#" or "C#". */
function pitchClass(n: string): string | null {
  // strip leading octave digits (supports "10C#" too)
  const noOct = n.replace(/^\d+/, "");
  // allow forms like "C", "C#", "D#", "A#"
  return /^[A-G](#)?$/.test(noOct) ? noOct : null;
}

function clampInt(v: number, min: number, max: number): number {
  const x = Math.floor(Number(v));
  if (!Number.isFinite(x)) return min;
  return Math.min(max, Math.max(min, x));
}
@Injectable({
  providedIn: 'root'
})


export class UtilityService {

 
  layoutToKeyAssignments(config:FlexBoardConfig , layout?:LayoutName)
  {
 return (computeKeyAssignments(config, layout));

  }
    constructor() { }
/************************************************************************************
** expandBol: expands .. streches the notes to base of maximum div without changing rendering or meaning
** Input: bol, length- current length of beat in div. Change div to new div. Like Dugun to Chougun notation
** Output : Expended notaton
** Example: Dhin ... can be Dhin~~~ div =4
*************************************************************************************/
expandBol =function (div,length,bol)    
{

    var stretchRatio=div/length;
    var result= [];
    bol.forEach(function (bolS) {result.push(bolS);
    var j;
    for (j=0; j< (stretchRatio-1); j++)
        {
        result.push('~');
        }
        
    });
    return(result);
}

/************************************************************************************
** convertTal: Converts linear taal notation to array of notes, all normailzed to the maxdiv.
** Input: bol, div - max div
** Output : Array of each beat or subbeat notation

*************************************************************************************/

 convertTal(div,bol)
 {
     // get all beats 
     var result=<any>[];
        var arNotes=bol.split (/\s/);
        let util=this;
        arNotes.forEach (function(note){
            
            var strLen=note.length;
            var i=0;
            let bolInBeat: Array<string>=[];
            for (i=0; i<strLen;i++)
                {
                if ((note[i]== '-')||(note[i]== '~'))
                    {
                    bolInBeat.push(note[i]);
                    
                    }
                else
                    {
                if (/^[A-Z]/.test(note[i]))
                        {
                    
                        var thisBol =note[i];
                        i++;
                        while (i < strLen && /[a-z0-9]/.test(note[i]))
                            {
                            thisBol+=note[i++];
                             
                            }
                        i--;
                        bolInBeat.push(thisBol);
                        }
                    }
                }
           util.expandBol(div,bolInBeat.length,bolInBeat).forEach(function(bol){
                
            
                result.push(bol);});
                
                
        });
        
     return(result);
 }

 

/************************************************************************************
** findDiv: returns maximum divisions in a beat found in a taal
** Input: Taal Beats Array of String - Notation for each beat
** Output : Maximum Divisions among all the beats in the given notation
*************************************************************************************/
 findDiv(r)
 {
    var l=r.length;
    var mx=1; var i=0;
    for (i=0; i < l; i++)
        {
                var mArray=r[i].match(/([A-Z]|\~|\-)/g);
                if (mArray)
                {
                var ct=mArray.length;
                if (ct > mx)
                    {
                    mx=ct;
                    }
                }
        }

 return mx;
 }


nameToIcon (name)
{
let file;
  if (name.search(/Piano/i)!=-1)
  {
    file="006-piano.svg";
    return (file);
  }
  if (name.search(/accordian/i)!=-1)
  {
 file="008-harmonium.svg";
 return (file);
  }
  if (name.search(/Harmonium/i)!=-1)
  {
 file="008-harmonium.svg";
 return (file);
  }
  if (name.search(/guitar/i)!=-1)
  {
    file="005-guitar.svg";
    return (file);
  }
  
  

  if (name.search(/violin/i)!=-1)
  {
    file="violin.svg";
    return (file);
  }

  if (name.search(/string/i)!=-1)
  {
    file="violin.svg";
    return (file);
  }
  if (name.search(/santoor/i)!=-1)
  {
    file="011-santoor.svg";
    return (file);
  }

  if (name.search(/sitar/i)!=-1)
  {
    file="007-sitar.svg";
    return (file);

  }
  
  if (name.search(/flute/i)!=-1)
  {
    file="flute.svg";
    return (file);
  }

  if (name.search(/bansuri/i)!=-1)
  {
    file="flute.svg";
    return (file);
  }
   
  if (name.search(/sarangi/i)!=-1)
  {
    file="violin2.svg";
    return (file);
  }
  if (name.search(/veena/i)!=-1)
  {
    file="veena.svg";
    return (file);
  }
  if (name.search(/sarod/i)!=-1)
  {
    file="erhu.svg";
    return (file);
  }
  if (name.search(/sax/i)!=-1)
  {
    file="bass_saxophone.svg";
    return (file);
  }
  if (name.search(/manjira/i)!=-1)
  {
    file="manjira.svg";
    return (file);
  }
  if (name.search(/Tabla/i)!=-1)
  {
    file="Tabla.svg";
    return (file);
  }
  if (name.search(/Taanpura/i)!=-1)
  {
    file="tanpura.svg";
    return (file);
  }
  return (file);

}


numberToSur(note) {
  const octaveFreeNumberToNote=['S','r','R','g','G','m','M','P','d','D','n','N'];
  var octave = 0;
  var suffix = '';
  if (note < 0) {
      octave = -1;
      suffix = '.';
  }
  if (note > 11) {
      octave = 1;
      suffix = "'";
  }
  note -= 12 * octave;

  var sur = octaveFreeNumberToNote[note];
  return (sur)
  //eturn ({ sur: sur, saptak: octave, octaved: sur + suffix , fullIndian: OctavedIndianNotes[note + (1 + octave) * 12]
}

getNoteText(key,indexIn?:number)
{

 let cKey=0;
let index;
 if (key)
 {

index=key.index;
 }
 else
 {
   index=indexIn;
 }

   let compOctave=4;
   let noteRele=index -compOctave*12;
   let octave=Math.floor(noteRele/12);
   let sur=noteRele%12;
   let prefix="";
   let suffix="";
   if (octave==-2)
   {
     prefix="..";

   }
   if (octave==-1)
   {
     prefix=".";
   }
   if (octave==1)
   {
     suffix="'";
   }
   if (octave==2)
   {
     suffix="*"
   }
   let text=prefix+this.numberToSur(sur)+suffix;
   return (text);
 }
 
 
 
  lockBodyScroll() {
    const body = document.querySelector('body');
    body.style.overflow = 'hidden';
  }
  unlockBodyScroll() {
    const body = document.querySelector('body');
    body.style.removeProperty('overflow');
  };


encrypt (text){
  return (text)
};

 decrypt = (text) => {
 return (text);
};




}

